import type { MaterialPage_CostUsagesList_CostUsage } from '..';

export const getRowId = (row: MaterialPage_CostUsagesList_CostUsage) =>
  row.cost._id;
